import {
    ReactNode,
    SyntheticEvent,
    useContext,
    useEffect,
    useMemo,
} from "react";
import { ThemeProvider } from "@emotion/react";
import theme from "../../../theme";
import NavBar from "../../NavBar/NavBar";
import {
    ClientDashBoardNavBarMenuItemId,
    DashboardNavBarMenuItem,
} from "../../../types";
import HomeIcon from "../../../public/icons/HomeIcon.svg";
import DossierIcon from "../../../public/icons/DossierIcon.svg";
import ActiveDossierIcon from "../../../public/icons/activeIcons/ActiveDossierIcon.svg";
import LibraryIcon from "../../../public/icons/LibraryIcon.svg";
import ActiveHomeIcon from "../../../public/icons/activeIcons/ActiveHomeIcon.svg";
import ActiveLibraryIcon from "../../../public/icons/activeIcons/ActiveLibraryIcon.svg";
import "../../components-styles.scss";
import { Grid } from "@mui/material";
import {
    CustomModalContext,
    DossierCreationContextProvider,
    LayoutBarContext,
    EstablishementInfosContextProvider,
    ContactsContextProvider,
} from "../../../contexts";

import CustomModal from "../../UIElements/CustomModal/CustomModal";
import Home from "../../AdminRegionSpace/Home/AdminRegionHome";
import LibraryDocument from "../../LibraryDocument/LibraryDocument";
import { scrollToTop } from "../../../helpers";
import Dossiers from "../../Dossiers/Dossiers";
import { homeLabel } from "../../../consts";

export default function AdminRegionLayout({ children }: { children: ReactNode }) {
    const {
        content,
        updateIsLayoutBarActive,
        updateContent,
        active,
        setActive,
    } = useContext(LayoutBarContext);

    const {
        modal: { content: customModalContent, title },
    } = useContext(CustomModalContext);

    const navBarMenuItems: DashboardNavBarMenuItem[] = useMemo(
        () => [
            {
                id: ClientDashBoardNavBarMenuItemId.HOMEPAGE,
                title: homeLabel,
                menuLabel: homeLabel,
                route: null,
                icon: HomeIcon,
                activeIcon: ActiveHomeIcon,
                onClick: () => {
                    updateContent(<Home />);
                    updateIsLayoutBarActive(true);
                },
            },
            {
                id: ClientDashBoardNavBarMenuItemId.DOSSIERS,
                title: "Dossiers",
                menuLabel: "Dossiers",
                icon: DossierIcon,
                activeIcon: ActiveDossierIcon,
                route: null,
                onClick: () => {
                    updateContent(<Dossiers />);
                    updateIsLayoutBarActive(true);
                },
            },
            {
                id: ClientDashBoardNavBarMenuItemId.LIBRARYDOCUMENTS,
                title: "Bibliothèque",
                menuLabel: "Bibliothèque",
                icon: LibraryIcon,
                activeIcon: ActiveLibraryIcon,
                route: null,
                onClick: () => {
                    updateContent(<LibraryDocument />);
                    updateIsLayoutBarActive(true);
                },
            },
        ],
        []
    );

    function handleChange(e: SyntheticEvent, value: string) {
        setActive(value);
    }

    useEffect(() => {
        updateContent(<Home />);
        updateIsLayoutBarActive(true);
        setActive(ClientDashBoardNavBarMenuItemId.HOMEPAGE);
        scrollToTop();
    }, []);

    /**
     * sx={{ width: "90rem", height: "50rem" }}
     */

    return (
        <ThemeProvider theme={theme}>
            <DossierCreationContextProvider>
                <EstablishementInfosContextProvider>
                    <ContactsContextProvider>
                        {/* <Box > */}
                        <Grid
                            container
                            sx={{
                                height: "50rem",
                            }}
                        >
                            <Grid
                                item
                                xs={0}
                                md={2.5}
                                zIndex={1}
                                sx={{
                                    height: "50rem",
                                    "@media (min-width: 900px)": {
                                        height: "unset",
                                    },
                                }}
                            >
                                <NavBar
                                    menuItems={navBarMenuItems}
                                    active={active}
                                    handleChange={handleChange}
                                />
                            </Grid>
                            <Grid
                                xs={1}
                                item
                                md={9.5}
                                sx={{
                                    maxWidth: "100%",
                                    "@media (max-width:1024px)": {
                                        "@media (min-width: 600px)": {
                                            maxWidth: "100%",
                                        },
                                    },
                                }}
                            >
                                {content}
                                <CustomModal title={title}>
                                    {customModalContent}
                                </CustomModal>
                            </Grid>
                        </Grid>
                        {/* </Box> */}
                    </ContactsContextProvider>
                </EstablishementInfosContextProvider>
            </DossierCreationContextProvider>
        </ThemeProvider>
    );
}
